'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withArtStore = function withArtStore(_ref) {
  var _ref$onCheckout = _ref.onCheckout,
      onCheckout = _ref$onCheckout === undefined ? function () {} : _ref$onCheckout,
      _ref$viewMode = _ref.viewMode,
      viewMode = _ref$viewMode === undefined ? 'editor' : _ref$viewMode,
      galleryInfo = _ref.galleryInfo,
      _ref$cartItems = _ref.cartItems,
      cartItems = _ref$cartItems === undefined ? [] : _ref$cartItems,
      _ref$cartItemsCount = _ref.cartItemsCount,
      cartItemsCount = _ref$cartItemsCount === undefined ? 0 : _ref$cartItemsCount;
  return function (ComposedComponent) {
    var ArtStoreHOC = function (_Component) {
      (0, _inherits3.default)(ArtStoreHOC, _Component);

      function ArtStoreHOC() {
        (0, _classCallCheck3.default)(this, ArtStoreHOC);
        return (0, _possibleConstructorReturn3.default)(this, (ArtStoreHOC.__proto__ || (0, _getPrototypeOf2.default)(ArtStoreHOC)).apply(this, arguments));
      }

      (0, _createClass3.default)(ArtStoreHOC, [{
        key: 'render',
        value: function render() {
          var actions = this.props.actions;

          var fullActions = (0, _extends3.default)({}, actions, { onCheckout: onCheckout });
          return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, (0, _extends3.default)({}, this.props, { actions: fullActions }), {
            viewMode: viewMode,
            galleryInfo: galleryInfo,
            cartItems: cartItems,
            cartItemsCount: cartItemsCount
          }));
        }
      }], [{
        key: 'displayName',
        get: function get() {
          return 'WithArtStore ' + (ComposedComponent.displayName || ComposedComponent.name || 'Component');
        }
      }]);
      return ArtStoreHOC;
    }(_react.Component);

    ArtStoreHOC.propTypes = (0, _extends3.default)({
      viewMode: _propTypes2.default.string,
      galleryInfo: _propTypes2.default.object.isRequired,
      cartItems: _propTypes2.default.array,
      cartItemsCount: _propTypes2.default.number
    }, ComposedComponent.propTypes);

    ArtStoreHOC.defaultProps = {
      viewMode: 'editor',
      cartItems: [],
      cartItemsCount: 0
    };

    return ArtStoreHOC;
  };
};

exports.default = withArtStore;